import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AppSettingsService as _appSettings } from './app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class PogodaNewsService {

  constructor(private _http: HttpClient, private _auth: AuthService) { }

  public model = 'pogoda-news';
  public storm = 'storm';

  list(data, interval): Observable<ListNews> {
    // check and set params of pagination
    const page = `p=${data.page ? data.page : 0}`;
    const size = `s=${data.size ? data.size : 20}`;
    const category = `c=${interval.type ? interval.type : ''}`;

    const year = interval.year ? '&year=' + (interval.year) : '';
    const month = interval.month ? '&month=' + (interval.month) : '';
    const params = `?${size}&${page}&${interval.type ? category : ''}${year}${month}`;

    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/now' + params;
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<ListNews>(uri, {headers: headers});
  }

  lastDays(): Observable<LastDaysNews[]> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/last-days';
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<LastDaysNews[]>(uri, {headers: headers});
  }

  get(id): Observable<NewsPostPutGetId> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/id/' + id;
    const headers = new HttpHeaders()
    // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<NewsPostPutGetId>(uri, {headers: headers});
  }
  getStormActions(id): Observable<NewsPostPutGetId> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.storm + '/action/' + id;
    const headers = new HttpHeaders()
    // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<NewsPostPutGetId>(uri, {headers: headers});
  }

}

interface LastDaysNews {
  "id": number,
  "date": string,
  "category": string,
  "title": string,
  "over": string
}

interface NewsPostPutGetId {
  title_ru: string,
  title_be: string,
  title_en: string,
  slug: string,
  text_ru: string,
  text_be: string,
  text_en: string,
  created_at: string,
  updated_at: string,
  published: number,
  type: string,
  id?: number
}
interface ListNews {
  data: NewsPostPutGetId[],
  count: number,
  page: number,
  first: boolean,
  last: boolean
}